import { formatNumber, formatPercentage } from '@/utils/format/number';
import type { MetricUnit } from '@/warranty-v3/entities/metric';

export function formatMetricValue(
  value: number,
  unit: MetricUnit,
  minimumFractionDigits: number = 0,
  maximumFractionDigits: number = 2,
): string {
  switch (unit) {
    case 'percent':
      return formatPercentage(
        value,
        minimumFractionDigits,
        maximumFractionDigits,
      );
    case 'MWh':
      return `${formatNumber(value, minimumFractionDigits, maximumFractionDigits)} MWh`;
  }
}

export function metricValueAxisLabel(unit: MetricUnit): string {
  switch (unit) {
    case 'percent':
      return 'Percentage';
    case 'MWh':
      return 'Energy Capacity';
  }
}

export function isPercentMetric(unit: MetricUnit): boolean {
  return unit === 'percent';
}
